<template>
  <Card class="pa-4">
    <FlexColumn>
      <Label size="h6" bold text="基本情報" />
      <FlexColumn class="properties">
        <FlexColumn v-if="gender">
          <Label text="性別" />
          <Label bold :text="gender" />
        </FlexColumn>
        <FlexColumn v-if="prefecture">
          <Label text="居住地域" />
          <Label bold :text="prefecture" />
        </FlexColumn>
        <FlexColumn v-if="applicant.currentPositions.length > 0">
          <Label text="経験のある職種" />
          <PositionsLabel bold :positions="applicant.currentPositions" />
        </FlexColumn>
        <FlexColumn v-if="student">
          <Label text="学生・社会人" />
          <Label bold :text="student" />
        </FlexColumn>
        <FlexColumn v-if="applicant.languages.length > 0">
          <Label text="語学" />
          <LanguagesLabel bold :languages="applicant.languages" />
        </FlexColumn>
      </FlexColumn>
    </FlexColumn>
  </Card>
</template>

<script>
import Card from "@/components/atoms/Card";
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import {mapGetters} from "vuex";
import PositionsLabel from "@/components/molecules/PositionsLabel";
import LanguagesLabel from "@/components/molecules/LanguagesLabel";
import ComponentMixin from "@/components/ComponentMixin";
import moment from "moment";

export default {
  mixins: [ComponentMixin],
  name: "ApplicantBasicCard",
  components: {LanguagesLabel, PositionsLabel, Label, FlexColumn, Card},
  props: {
    applicant: {
      type: Object
    }
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    gender() {
      return this.constsToText(this.applicant.gender, this.consts.gender)
    },
    prefecture() {
      if (this.applicant.prefecture === 48) {
        return this.applicant.countryName
      }
      return this.constsToText(this.applicant.prefecture, this.consts.prefectures)
    },
    student() {
      return this.applicant.academic.graduatedYear > moment().year() ? '学生' : '社会人'
    }
  }
}
</script>

<style scoped>
.properties > *:not(:last-child) {
  border-bottom: rgba(0, 0, 0, 0.12) solid thin;
  margin-bottom: 8px;
  padding-bottom: 8px;
}
</style>